import { ArrowLeft } from "lucide-react";
import React from "react";
import { useHistory } from "react-router-dom";
import { Button } from "../../Button";
import Tab from "../Tab/Tab";
import { ITopBarProps } from "../types";
import * as S from "./styled";

const TopBar: React.FC<ITopBarProps> = ({
    sidebarButton,
    breadcrumbs,
    settings,
    actions,
    search,
    tabs,
    menu,
    showMenu = false,
    darkMode = false,
    title,
    backlink
}) => {
    const history = useHistory();
    const isDoubleBar: boolean = !!(search || backlink || title || tabs || actions);

    return (
        <S.Wrapper $darkMode={darkMode} $doubleBar={isDoubleBar}>
            <S.BaseBar $darkMode={darkMode}>
                <S.BaseSection>
                    <S.SideBarButtonWrapper>{sidebarButton}</S.SideBarButtonWrapper>
                    {breadcrumbs && breadcrumbs}
                </S.BaseSection>

                {settings && <S.BaseSection>{settings}</S.BaseSection>}
            </S.BaseBar>

            {isDoubleBar && (
                <S.SecondBar>
                    {search && <S.SearchWrapper>{search}</S.SearchWrapper>}
                    {backlink && (
                        <Button
                            icon={<ArrowLeft />}
                            onClick={() => {
                                if (backlink.url && history.length === 1) history.push(backlink.url);
                                else history.goBack();
                            }}
                            title={backlink.title}
                            trackName={backlink.trackName}
                            variant="tertiary"
                        />
                    )}
                    {title && <S.TitleWrapper>{title}</S.TitleWrapper>}
                    {tabs && tabs.length > 0 && (
                        <S.Tabs>
                            {tabs.map(tab => (
                                <Tab key={tab.title} {...tab} />
                            ))}
                        </S.Tabs>
                    )}
                    {actions && <S.ActionsWrapper>{actions}</S.ActionsWrapper>}
                </S.SecondBar>
            )}
            {showMenu && menu}
        </S.Wrapper>
    );
};

export default TopBar;
